import LxcError from "~/core/models/LxcError.class";
import type { SectorUpdatePayload } from "~/modules/sector/models/SectorUpdatePayload.interface";
import sectorsService from "~/modules/sector/services/sectors.service";

export function useUpdateSector(organizationCode?: number) {
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function updateSector(
    sectorCode: number,
    sectorUpdatePayload: SectorUpdatePayload,
  ): Promise<void> {
    isLoading.value = true;
    error.value = undefined;

    if (organizationCode) {
      const response = await sectorsService.updateSector(
        organizationCode,
        sectorCode,
        sectorUpdatePayload,
      );
      if (LxcError.check(response)) {
        error.value = response;
      }
    } else {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = false;
  }

  return {
    updateSector,
    isLoading,
    error,
  };
}
